import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import {
    Box,
    Dialog,
    DialogContent,
    DialogContentText,
    IconButton,
    Slide,
    useMediaQuery, useTheme,
    Button,
    Typography,
    ListItemButton, ListItemText, ListItemSecondaryAction, ListItem, List
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';


import { List as IList } from 'immutable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import giftCardDetailsPageMessagesV2 from './messages/giftCardDetailsPageMessages';

const Transition = React.forwardRef((props, ref) => <Slide direction='up' ref={ref} {...props} />);

const CarousalCategoryPicker = ({
    intl, selectedFaceplateCategory, allCategoryList, onCategorySelect, refreshCarousel,
    callbackOnCategorySelectOrClose, cardType, stepName
}) => {
    const [openCategory, setopenCategory] = React.useState(false);
    const handleOpen = () => setopenCategory(true);

    const segmentData = {
        currentSelection: selectedFaceplateCategory,
        context: `${stepName} page category picker modal`,
        title: `${cardType} category picker modal`
    };

    const handleCloseModel = (value) => {
        setopenCategory(value);
        const segmentUpdatedData = { ...segmentData, newSelection: '' };
        callbackOnCategorySelectOrClose(segmentUpdatedData);
    };

    const handleonCategorySelect = (value) => {
        onCategorySelect(value);
        setopenCategory(false);
        refreshCarousel();
        const segmentUpdatedData = { ...segmentData, newSelection: value };
        callbackOnCategorySelectOrClose(segmentUpdatedData);
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            {allCategoryList.size > 1 && (
                <Button
                    className='DenomCurrencyPicker'
                    onClick={handleOpen}
                    disableRipple
                    aria-expanded={openCategory}
                    aria-haspopup="dialog"
                >
                    <div className='CategoryPickerText'>
                        <Typography component='span' className='pickerTextWrap'>
                            {selectedFaceplateCategory && selectedFaceplateCategory}
                        </Typography>
                        <ExpandMoreIcon />
                    </div>
                    <span className="sr-only"> - Change category</span>
                </Button>
            )}
            <Dialog
                open={openCategory}
                className='locale-currency-popup-modal'
                onClose={() => { handleCloseModel(); }}
                scroll='paper'
                TransitionComponent={isMobile ? Transition : undefined}
                fullWidth
                maxWidth='sm'
                aria-labelledby='category-heading'
                PaperProps={{
                    role: 'dialog',
                    'aria-modal': 'true'
                }}
            >
                <Box>
                    <Typography
                        variant='h2'
                        className='pdpCurrencyPickerTitle'
                        id="category-heading"
                    >
                        {intl.formatMessage(giftCardDetailsPageMessagesV2.CategoryPickerModalHeader)}
                    </Typography>
                    <IconButton
                        className='close-currency-locale-modal'
                        aria-label='Close category dialog'
                        onClick={() => { handleCloseModel(); }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <DialogContent className='tab-content'>
                    <DialogContentText>
                        <Box className='currency-locale-wrapper carousal-category-wrapper'>
                            <List>
                                {allCategoryList.map(category => (
                                    <Fragment>
                                        <ListItem key={category} disablePadding>
                                            <ListItemButton
                                                className='list-item-button'
                                                onClick={() => handleonCategorySelect(category)}
                                                aria-pressed={selectedFaceplateCategory === category}
                                            >
                                                <ListItemText
                                                    primary={`${category}`}
                                                />
                                                {selectedFaceplateCategory === category && (
                                                    <ListItemSecondaryAction>
                                                        <CheckIcon className='check-icon' />
                                                    </ListItemSecondaryAction>
                                                )}
                                            </ListItemButton>
                                        </ListItem>
                                    </Fragment>
                                ))}
                            </List>
                        </Box>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </>
    );
};

CarousalCategoryPicker.defaultProps = {
    refreshCarousel: () => { },
    callbackOnCategorySelectOrClose: () => { },
    cardType: '',
    stepName: ''
};

CarousalCategoryPicker.propTypes = {
    intl: intlShape.isRequired,
    selectedFaceplateCategory: PropTypes.string.isRequired,
    allCategoryList: PropTypes.instanceOf(IList).isRequired,
    onCategorySelect: PropTypes.func.isRequired,
    refreshCarousel: PropTypes.func,
    cardType: PropTypes.string,
    stepName: PropTypes.string,
    callbackOnCategorySelectOrClose: PropTypes.func
};

export default injectIntl(CarousalCategoryPicker);
